import {endpoints} from './endpoints'
import request from '../request'

export function getUserMediciones (data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.userMediciones,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}
export function startRemoteTest (data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.startRemoteTest,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}

export function autoMedicion (data) {
	return new Promise((resolve) => {
		request({
			url: endpoints.autoMedicion,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}

export function deactivateAutoMedicion () {
	return new Promise((resolve) => {
		request({
			url: endpoints.deactivateAutoMedicion,
			method: 'post',
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				resolve(error)
			})
	})
}